import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import trans from 'counterpart';
import moment from 'moment';
import { CarouselItem } from 'reactstrap';
import { createMoreInfoUrl } from '../../actions';
import { hasAdults, getPreference } from '../../../../selectors/preferenceSelectors';
import { getBookingUrl } from '../../../../utilities/preferenceUtilities';
import AccommodationLabel from './AccommodationLabel';
import AnchorButton from './AnchorButton';
import Carousel from '../../../../components/Carousel';
import CarouselPlaceholder from './CarouselPlaceholder';
import Popover from './Popover';
import PriceTagAvailable from './PriceTagAvailable';
import AddToCompareResources from '../../../compare/components/AddToCompareResources';
import PriceTagUnavailable from './PriceTagUnavailable';
import Image from '../../../media/components/Image';
import { PREFERENCE_SUBJECTS } from '../../../../constants/preferences';
import { DISPLAY_DATE } from '../../../../constants/dates';
import { selectedPropertiesWithPreferenceCost } from '../../../reservation/selectors';
import { APP_BEEKSEBERGEN } from '../../../../constants/apps';

const classnames = parts => parts.filter(p => !!p).join(' ');
const isIE11 = typeof navigator !== 'undefined' ? (navigator.appVersion.indexOf('Trident/') > -1 || navigator.userAgent.indexOf('Edge') > -1) : false;

class AccommodationResult extends Component {
  getVisibleProperties = () => this.props.accommodationType.properties.filter(p => p.visible_on_index);

  getMoreInfoRoute = () => {
    const { accommodationType: { slug }, subjectPreference } = this.props;
    const moreInfoUrlObject = {
      subjects: Object.keys(subjectPreference || {}).map(subject => `${subject}:${subjectPreference[subject]}`)
    };
    return `/${slug}?${createMoreInfoUrl(moreInfoUrlObject)}`;
  }

  getBookingRoute = () => {
    const { result, subjectPreference, selectedPreferences } = this.props;

    return getBookingUrl(result, subjectPreference, selectedPreferences);
  }

  formatName = name => name.toLowerCase().split(' ').join('-');

  isAvailable = () => {
    const { isUnavailable, result } = this.props;
    return result.arrival_date && result.quantity > 0 && isUnavailable !== true;
  }

  render = () => {
    const { hasAdults, result, accommodationType, unavailableMessage, display } = this.props;
    if (!accommodationType) return null;

    return (
      <div className="result accommodation-result" id={`result-${result.id}`}>
        <div className="result-inner">
          <div
            className={classnames(['row', !result.arrival_date && 'row-disabled'])}
          >
            <div className="result-left">
              <div
                id={`carousel${result.id}`}
                className="carousel slide"
                data-ride="carousel"
                data-interval="false"
              >
                {accommodationType.label_new === 1 && <div className="label-new" />}
                {accommodationType.images && accommodationType.images.length > 0 && (
                  <Carousel>
                    {accommodationType.images.map(image => (
                      <CarouselItem key={image.id}>
                        <Image
                          file={image.reference}
                          filter="thumbnail_square"
                          attr={{
                            className: 'img-fluid',
                            alt: image.alt,
                          }}
                        />
                      </CarouselItem>
                    ))}
                  </Carousel>
                )}

                {(!accommodationType.images || accommodationType.images.length === 0) && (
                  <CarouselPlaceholder />
                )}

                {/* Resort highlight */}
                {process.env.RAZZLE_APP === APP_BEEKSEBERGEN && accommodationType.resort.id === 2041 && (
                  <AccommodationLabel
                    classNames={classnames([
                      'label-srbb',
                      'bg-red-light',
                      isIE11 ? 'crown-holder-ms' : 'crown-holder',
                    ])}
                    text={trans('resort.safari_resort')}
                    source="/img/icons/BB-SR-5-kroontjes.svg"
                  />
                )}
                {process.env.RAZZLE_APP === APP_BEEKSEBERGEN && accommodationType.resort.id !== 2041 && (
                  <AccommodationLabel
                    classNames={classnames([
                      'label-vpbb',
                      'bg-orange-light',
                      isIE11 ? 'crown-holder-ms' : 'crown-holder'
                    ])}
                    text={trans('resort.vakantiepark')}
                    source="/img/icons/BB-VP-4-kroontjes.svg"
                  />
                )}
              </div>
            </div>

            <div className="result-right">
              <div className="row">
                <div className="details">
                  <div className="details-inner">
                    <h2>
                      <Link to={`/${accommodationType.slug}`}>
                        {accommodationType.display_name || accommodationType.name}
                      </Link>
                    </h2>
                    {display !== 'grid' && (
                      <div className="extra" dangerouslySetInnerHTML={{ __html: accommodationType.all_in_description }} />
                    )}

                    <div className="date-holder">
                      {result.arrival_date && (
                        <div className="date-none">
                          <span className="d-block">{moment(result.arrival_date).format(DISPLAY_DATE)}</span>
                          <span>
                            {`${result.nights} ${result.nights > 1 ? trans('stay.nights') : trans('stay.night')} ${result.nights + 1}`} 
                          </span>
                        </div>
                      )}
                    </div>
                    {this.getVisibleProperties().length > 0 && (
                      <ul className="properties list-unstyled clearfix">
                        {this.getVisibleProperties().map(property => (
                          <li key={property.id} className={`property property-${property.property.id}`}>
                            {property.property.icon && (
                              <i className="material-icons">{property.property.icon}</i>
                            )}
                            {`${property.value ? property.value : ''} ${property.property.display_name || property.property.name}`}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

                {display === 'grid' && (
                  <Fragment>
                    <div className="pricing">
                      <div className="clearfix">
                        <div className="date-holder">
                          {result.arrival_date && (
                            <div className="date-none">
                              <span className="d-block">{moment(result.arrival_date).format(DISPLAY_DATE)}</span>
                              <span>
                                {`${result.nights} ${result.nights > 1 ? trans('stay.nights') : trans('stay.night')}, ${result.nights + 1} ${trans('stay.days')}`}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="extra" dangerouslySetInnerHTML={{ __html: accommodationType.all_in_description }} />
                  </Fragment>
                )}
                {display !== 'grid' && (
                  <div className="pricing-list">
                    <div className="clearfix">
                      <div className="top-holder">
                        <div className="date-holder">
                          {result.arrival_date && (
                            <div className="date-none">
                              <span className="d-block">{moment(result.arrival_date).format(DISPLAY_DATE)}</span>
                              <span>
                                {`${result.nights} ${result.nights > 1 ? trans('stay.nights') : trans('stay.night')}, ${result.nights + 1} ${trans('stay.days')}`}
                              </span>
                            </div>
                          )}
                        </div>
                        {result.quantity <= 3 && (
                          <span className="availability d-block">{trans('newyse.accommodation.almost_soldout')}</span>
                        )}
                      </div>
                      <div className="bottom-holder">
                        <div className="details-included small p-2">
                          <Popover id={accommodationType.id} description={trans('stay.including')}>
                            <div dangerouslySetInnerHTML={{ __html: accommodationType.all_in_device_description }} />
                          </Popover>
                        </div>
                        <div className="price-holder">
                          {result.arrival_date && (
                            <div className="price-tag compact">
                              <span className="price">{`${result.all_in_price},-`}</span>
                              {result.all_in_price < result.from_price && (
                                <s>{`${result.from_price},-`}</s>
                              )}
                              {result.special_name && (
                                <p className="text-discount" style={{ wordBreak: 'break-word' }}>
                                  {result.special_name}
                                </p>
                              )}
                            </div>
                          )}
                          {!result.arrival_date && (
                            <div className="price-tag compact">
                              <span>
                                {trans('newyse.accommodation.unavailable')}
                                <a
                                  // href={getMoreInfoRoute(result)}
                                  style={{ textDecoration: 'underline' }}
                                  dangerouslySetInnerHTML={{ __html: trans('newyse.accommodation.check') }}
                                />
                                {` ${trans('newyse.accommodation.unavailable2')}`}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {display === 'grid' && (
                <div className="price-holder">
                  <div className="details-included small p-2">
                    <Popover id={accommodationType.id} description={trans('stay.including')}>
                      <div dangerouslySetInnerHTML={{ __html: accommodationType.all_in_device_description }} />
                    </Popover>
                  </div>
                  {this.isAvailable() && (
                    <PriceTagAvailable {...result} />
                  )}
                  {!this.isAvailable() && (
                    <PriceTagUnavailable message={unavailableMessage} moreInfoLink={this.getMoreInfoRoute()} />
                  )}
                </div>
              )}
              <div className="row btn-row">
                {display !== 'grid' && (
                  <div className="col-md-4">
                    <AddToCompareResources id={result.resource_id} />
                  </div>
                )}
                <div className={display === 'grid' ? 'col-md-12' : 'col-md-8 text-md-right'}>
                  <AnchorButton
                    text={trans('button.more_info')}
                    href={this.getMoreInfoRoute()}
                    classNames="btn btn-acco btn-transparent-ghost"
                  />
                  {/* TO DO: Add condition to AnchorButton direct boeken */}
                  <AnchorButton
                    text={trans('newyse.accommodation.book')}
                    href={this.getBookingRoute()}
                    classNames="btn ml-2 btn-booking"
                    disabled={!this.isAvailable() || !hasAdults}
                  />
                  {/* !this.isAvailable() && isBookable && (
                    <button
                      type="button"
                      disabled
                      className="btn btn-gray ml-2"
                    >
                      {trans('button.sold_out')}
                    </button>
                  ) */}
                  {display === 'grid' && <div><AddToCompareResources id={result.resource_id} /></div>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AccommodationResult.propTypes = {
  accommodationType: PropTypes.object,
  display: PropTypes.string,
  hasAdults: PropTypes.bool,
  // Determines if it's allowed to book this accommodation.
  // E.g. this is false in a pre-event fase.
  isBookable: PropTypes.bool,
  // Determines if an accommodation is available.
  // During event sales the reservations go faster than the sync can handle so it's
  // required to manually mark an accommodation as unavailable without affecting the sync.
  isUnavailable: PropTypes.bool,
  result: PropTypes.object,
  selectedPreferences: PropTypes.array,
  subjectPreference: PropTypes.object,
  unavailableMessage: PropTypes.string,
};

const mapStateToProps = state => ({
  display: state.preferences.display,
  subjectPreference: getPreference(PREFERENCE_SUBJECTS)(state),
  selectedPreferences: selectedPropertiesWithPreferenceCost(state),
  hasAdults: hasAdults(state)
});

export default connect(mapStateToProps)(AccommodationResult);
